<h1 mat-dialog-title class="mat-title">{{data.header}}</h1>
<div mat-dialog-content>
    <div class="col-sm-8 row">
        <div class="col-sm-12 row">
            <span class="col-sm-12 col-md-6 item-label">{{'ACCOUNT.REF' | translate}}:</span>
            <span class="col-sm-12 col-md-6 mb-1">{{data.booking.id}}</span>
        </div>
        <div class="col-sm-12 row">
            <span class="col-sm-12 col-md-6 item-label">{{'ACCOUNT.SERVICE' | translate}}:</span>
            <span class="col-sm-12 col-md-6 mb-1">{{data.booking.service_name}}</span>
        </div>
        <div class="col-sm-12 row">
            <span class="col-sm-12 col-md-6 item-label">{{'ACCOUNT.LOCATION' | translate}}:</span>
            <span class="col-sm-12 col-md-6 mb-1">{{data.booking.full_describe.split('-
                ')[1].replace(data.booking.resource_name,"").replace(" at ","")}}</span>
        </div>
        <div class="col-sm-12 row">
            <span class="col-sm-12 col-md-6 item-label">{{'ACCOUNT.DATE' | translate}}:</span>
            <span class="col-sm-12 col-md-6 mb-1">{{data.booking.datetime.format('Do MMMM YYYY')}}</span>
        </div>
        <div class="col-sm-12 row">
            <span class="col-sm-12 col-md-6 item-label">{{'ACCOUNT.TIME' | translate}}:</span>
            <span class="col-sm-12 col-md-6 mb-1">{{data.booking.time}} - {{data.booking.endTime}}</span>
        </div>
    </div>
    <hr />

    <div *ngIf="data.action === 'cancel'" class="cancel-messages">
        <p *ngIf="cancelMessage">{{'ACCOUNT.CANCEL_MESSAGE' | translate}}</p>
        <p *ngIf="cancelPromptMessage">{{'ACCOUNT.CANCEL_PROMPT' | translate}}</p>
        <p *ngIf="cancelPassed">{{'ACCOUNT.CANCEL_PERIOD_PASSED' | translate}}</p>
    </div>

    <div *ngIf="data.action === 'modify'">
        <app-mat-calendar [service]="data.service" [location]="data.location"
            (selectSlotUpdate)="selectedSlotCheck($event)" class="row" (spinStop)="test($event)">
        </app-mat-calendar>

        <hr />

        <div class="mt-1">
            <p *ngIf="slotEmpty" class="slotEmpty">{{'ACCOUNT.SLOT_EMPTY' | translate}}</p>
            <p *ngIf="selectedSlot" class="selectedMessage">You have chosen to reschedule to the following date and
                time: {{selectedSlot | date: 'd MMMM y, HH:mm'}}</p>
        </div>
    </div>

    <div *ngIf="data.action === 'details'">
        <span *ngIf="!showQuestions && questionsLoaded">
            <span *ngFor="let question of data.booking.questions">
                <div *ngIf="question.value !== ''" class="row mb-3">
                    <label class="col-sm-4" for="{{question.question_text}}">{{question.question_text}}</label>
                    <input type="text" [disabled]="true" value="{{translateAnswer(question.value)}}" class="col-sm-8"
                        id="{{question.question_text}}" />
                </div>
            </span>
        </span>

        <div *ngIf="loading && showQuestions">
            <mat-spinner class="themed-spinner" aria-label="loading questions"></mat-spinner>
        </div>

        <div *ngIf="!loading && showQuestions">
            <form [formGroup]="bookingQuestionsForm" autocomplete="off" class="col-sm-12 col-md-12 col-lg-12">
                <h4 class="mt-1 pb-4">{{'COMMON.BOOKING_INFORMATION' | translate}}</h4>
                <div *ngFor="let question of bookingQuestions;">

                    <div *ngIf="question.visible && !question.admin_only && question.detail_type == 'heading'">
                        <p>
                            <span *ngIf="question.id === 461">
                                <b style="color: #c90505;">{{question.name}}</b>
                            </span>
                            <span *ngIf="question.id !== 461">
                                <b *ngIf="question.id == 453 || question.id == 499">{{question.name}}</b>
                                <b *ngIf="question.id != 453 && question.id != 499">{{question.name}}</b>
                            </span>

                        </p>
                        <span *ngIf="question.id === 461">
                            <span *ngIf="question.help_text" class="help-text mb-3" tabindex="0" style="color: #c90505;"
                                [innerHTML]="question.help_text">
                            </span>
                        </span>
                        <span *ngIf="question.id !== 461">
                            <span *ngIf="question.help_text" class="help-text mb-3" tabindex="0"
                                [innerHTML]="question.help_text">
                            </span>
                        </span>
                    </div>

                    <div class="form-group"
                        *ngIf="question.visible && !question.admin_only && question.detail_type == 'text_field'">
                        <label
                            *ngIf="(question.name === 'Vehicle registration' && this.myVehicles.length === 0) || question.name !== 'Vehicle registration'"><span
                                *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                                *</span> {{question.name}}</label>


                        <ng-container
                            *ngIf="question.name === 'Vehicle make' || question.name === 'Vehicle model' || question.name === 'Vehicle colour' || question.name === 'What type of vehicle will you be arriving in?'">
                            <!-- 'Registration number' reference == 4 (Might need changing when merged in if id changes) -->
                            <!-- <ng-container *ngIf="this.myVehicles.length > 0">
                                <input maxlength="20" *ngIf="question.reference != 4" type="text"
                                    class="form-control mb-3" formControlName="{{question.reference}}"
                                    attr.aria-label="{{question.name}} input field"
                                    oninput="this.value = this.value.toUpperCase()" disabled>
                                <input maxlength="20" *ngIf="question.reference === 4" type="text"
                                    class="form-control mb-3" formControlName="{{question.reference}}"
                                    attr.aria-label="{{question.name}} input field"
                                    oninput="this.value = this.value.toUpperCase()" disabled>
                            </ng-container> -->
                            <!-- *ngIf="this.myVehicles.length === 0" -->
                            <ng-container>

                                <input maxlength="20" type="text" class="form-control mb-3"
                                    formControlName="{{question.reference}}"
                                    attr.aria-label="{{question.name}} input field" disabled
                                    oninput="this.value = this.value.toUpperCase()">
                            </ng-container>

                        </ng-container>

                        <ng-container
                            *ngIf="(question.name === 'Vehicle make' || question.name === 'Vehicle model' || question.name === 'Vehicle colour' || question.name === 'Vehicle registration' || question.name === 'What type of vehicle will you be arriving in?') === false">
                            <!-- 'Registration number' reference == 4 (Might need changing when merged in if id changes) -->
                            <input *ngIf="question.reference != 4" type="text" class="form-control mb-3"
                                formControlName="{{question.reference}}" attr.aria-label="{{question.name}} input field"
                                oninput="this.value = this.value.toUpperCase()">
                            <input *ngIf="question.reference === 4" type="text" class="form-control mb-3"
                                formControlName="{{question.reference}}" attr.aria-label="{{question.name}} input field"
                                oninput="this.value = this.value.toUpperCase()">
                        </ng-container>

                        <!--  vehicle lookup -->

                        <ng-container *ngIf="question.name === 'Vehicle registration'">
                            <!-- <ng-container *ngIf="this.myVehicles.length === 0"> -->
                            <div class="form-group">
                                <div class="row ml-0 mr-0" style="margin: 0px;">
                                    <input (keydown.space)="$event.preventDefault();"
                                        (keydown.spacebar)="$event.preventDefault();" type="text"
                                        class="form-control" formControlName="{{question.reference}}"
                                        role="textbox" style="width: 66%;"
                                        oninput="this.value = this.value.replace(/\s/g, '').toUpperCase()">
                                    <!-- <button type="button" style="margin: 1px;"
                                        class="btn btn-primary col-sm-4 mb-0  govuk-button button-sizer"
                                        [disabled]="!bookingForm[question.reference].valid" (click)="getVehicle()">Find
                                        vehicle</button> -->
                                </div>

                                <span *ngIf="vehicleStatus == 1" style="color: #36B37E; font-weight: 600;">Vehicle
                                    found. Please
                                    proceed.</span>

                                <span *ngIf="vehicleStatus == 2" style="color: #c90505; font-weight: 600;">
                                    Vehicle details not confirmed by DVLA, please try again, or contact <a
                                    href="mailto:bookings@wrwa.gov.uk">bookings&#64;wrwa.gov.uk</a> or call <a
                                    href="tel:02088712788">020 8871 2788</a>
                                </span>

                                <span *ngIf="vehicleStatus == 3" style="color: #c90505; font-weight: 600;">
                                    Vehicle details not confirmed by DVLA, please try again, or contact <a
                                    href="mailto:bookings@wrwa.gov.uk">bookings&#64;wrwa.gov.uk</a> or call <a
                                    href="tel:02088712788">020 8871 2788</a>
                                </span>

                            </div>

                            <!-- 
                            <input type="text" class="form-control mb-3" formControlName="{{question.reference}}"
                                attr.aria-label="{{question.name}} input field"
                                oninput="this.value = this.value.toUpperCase().replace(' ','').substr(0,10)"> -->

                            <!-- </ng-container> -->
                            <!-- <ng-container *ngIf="this.myVehicles.length > 0">
                                <div class="form-group">
                                    <label><span *ngIf="question.required" aria-hidden="true"
                                            class="form-field-required-marker">
                                            * </span>Select your vehicle for this HWRC visit.
                                    </label>

                                    <select formControlName="{{question.reference}}" [value]='-1' class="form-control"
                                        (change)="populateStoredVehicleDetails()" attr.aria-label="{{question.name}}">

                                        <option></option>
                                        <option *ngFor="let option of myVehicles" [value]="option.vehicle_registration">
                                            {{option.vehicle_registration}}
                                        </option>
                                    </select>
                                    <span class="help-text mb-3" tabindex="0">
                                        If the vehicle is not displayed, please go to 'My account' at the top of the
                                        page where you can add/remove vehicles.
                                    </span>
                                </div>
                            </ng-container> -->
                        </ng-container>


                        <div *ngIf="submitted && bookingForm[question.reference].errors?.required" role="alert"
                            tabindex="0" class="invalid-feedback">
                            {{question.name}} {{'COMMON.IS_REQUIRED' | translate}}</div>

                        <span *ngIf="question.help_text && question.name !== 'Vehicle colour'" class="help-text mb-3"
                            tabindex="0" [innerHTML]="question.help_text">
                        </span>
                        <span *ngIf="question.help_text && question.name === 'Vehicle colour'" class="help-text mb-3"
                            tabindex="0" [innerHTML]="'Please only note the nearest base colour, e.g. silver'">
                        </span>
                    </div>

                    <ng-container *ngIf="(question.id === postcode_id || question.id === address_id)">
                        <ng-container *ngIf="myAddresses.length === 0">
                            <div class="form-group" *ngIf="question.reference === postcode_id">
                                <label><span aria-hidden="true" class="form-field-required-marker">
                                        *</span> {{'COMMON.POSTCODE1' | translate}} <span
                                        style="font-weight: bold; text-decoration: underline; ">{{'COMMON.POSTCODE2' |
                                        translate}}</span>{{'COMMON.POSTCODE3' | translate}}</label>
                                <div class="row ml-0 mr-0">
                                    <input (keydown.space)="$event.preventDefault();"
                                        (keydown.spacebar)="$event.preventDefault();" type="text"
                                        class="form-control col-sm-8" formControlName="{{question.reference}}"
                                        role="textbox" oninput="this.value = this.value.toUpperCase()">
                                    <button type="button"
                                        class="btn btn-primary col-sm-4 mb-0  govuk-button button-sizer"
                                        [disabled]="!bookingForm[postcode_id].value"
                                        (click)="getAddress()">{{'COMMON.FIND_ADDRESS'
                                        |
                                        translate}}</button>
                                </div>
                                <div *ngIf="bookingForm[postcode_id].errors?.addressNotFound" role="alert" tabindex="0"
                                    class="invalid-feedback">
                                    {{bookingForm[postcode_id].errors?.addressNotFound}}</div>
                                <div *ngIf="bookingForm[postcode_id].errors?.invalidPostcode" role="alert" tabindex="0"
                                    class="invalid-feedback">
                                    {{bookingForm[postcode_id].errors?.invalidPostcode}}</div>
                                <div *ngIf="submitted && bookingForm[postcode_id].errors" class="invalid-feedback">
                                    <div *ngIf="bookingForm[postcode_id].errors.required" role="alert" tabindex="0">
                                        Postcode is required</div>
                                </div>
                                <div *ngIf="submitted && bookingForm[address_id].errors" class="invalid-feedback">
                                    <div *ngIf="bookingForm[address_id].errors.required && !showingAddresses"
                                        role="alert" tabindex="0">
                                        Please click 'FIND ADDRESS'</div>
                                </div>
                            </div>

                            <div class="form-group" *ngIf="addresses.length > 0 && question.reference === address_id">
                                <label><span aria-hidden="true" class="form-field-required-marker">
                                        *</span> {{'COMMON.ADDRESS' | translate}}</label>
                                <select formControlName="{{question.reference}}" class="form-control"
                                    attr.aria-label="Select address">
                                    <option value="">Please select</option>
                                    <option *ngFor="let item of addresses" [ngValue]="item">
                                        {{item?.address.ADDRESS}}
                                    </option>
                                </select>
                            </div>
                            <div *ngIf="submitted && bookingForm[address_id].errors && !bookingForm[postcode_id].errors"
                                class="invalid-feedback">
                                <div *ngIf="bookingForm[address_id].errors.required  && question.id === address_id"
                                    role="alert" tabindex="0">
                                    An address is required</div>
                            </div>
                            <div
                                *ngIf="this.bookingQuestionsForm.value[address_id].address && question.id === address_id">
                                <span *ngIf="!localAddress()" style="font-weight:bolder; color: #c90505;"
                                    class="invalid-feedback">
                                    As this address is not within the Kent administrative area, a £10 per visit
                                    cross-border fee will be applicable when disposing of waste from this address.
                                    Payment on arrival (card payments only).
                                    Please see our <a target="_blank" href="https://kent.gov.uk/hwrccrossborder">cross
                                        border policy</a> for more information.
                                </span>
                            </div>
                            <!-- postcode question's helptext -->
                            <span *ngIf="question.help_text" class="help-text mb-3" tabindex="0"
                                [innerHTML]="question.help_text">
                            </span>
                        </ng-container>
                        <ng-container *ngIf="myAddresses.length > 0">
                            <div class="form-group" *ngIf="question.reference.toString() === address_id.toString()">
                                <label><span aria-hidden="true" class="form-field-required-marker">
                                        * </span>Select the address where the waste is coming from.
                                </label>
                                <select formControlName="{{question.reference}}" [value]='-1' class="form-control"
                                    (change)="getPostcode()" attr.aria-label="{{question.reference}}">

                                    <option></option>
                                    <option *ngFor="let option of myAddresses" [value]="option.address">
                                        {{option.address}}
                                    </option>

                                </select>
                                <div *ngIf="submitted && bookingForm[address_id].errors" class="invalid-feedback">
                                    <div *ngIf="bookingForm[address_id].errors.required" role="alert" tabindex="0">
                                        An address is required</div>
                                </div>
                                <div *ngIf="this.bookingQuestionsForm.value[address_id]">
                                    <span *ngIf="!idLocalAddress" style="font-weight:bolder; color: #c90505;"
                                        class="invalid-feedback">
                                        1 As this address is not within the Kent administrative area, a £10 per visit
                                        cross-border fee will be applicable when disposing of waste from this address.
                                        Payment on arrival (card payments only).
                                        Please see our <a target="_blank"
                                            href="https://kent.gov.uk/hwrccrossborder">cross
                                            border policy</a> for more information.
                                    </span>
                                </div>
                                <span class="help-text mb-3" tabindex="0">
                                    If you need to change your address, please go to 'My account' at the top of the page
                                </span>
                            </div>
                        </ng-container>
                    </ng-container>

                    <div class="form-group"
                        *ngIf="question.visible && !question.admin_only && question.detail_type == 'text_area'">
                        <label><span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                                *</span> {{question.name}}</label>
                        <textarea class="form-control" formControlName="{{question.reference}}"
                            attr.aria-label="{{question.name}} text area"></textarea>

                        <div *ngIf="submitted && bookingForm[question.reference].errors?.required" role="alert"
                            tabindex="0" class="invalid-feedback">
                            {{question.name}} {{'COMMON.IS_REQUIRED' | translate}}</div>

                        <span *ngIf="question.help_text" class="help-text mb-3" tabindex="0"
                            [innerHTML]="question.help_text">
                        </span>
                    </div>

                    <div class="form-group"
                        *ngIf="question.visible && !question.admin_only && question.detail_type == 'number'">
                        <label><span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                                *</span> {{question.name}}</label>
                        <input type="search" class="form-control" formControlName="{{question.reference}}"
                            attr.aria-label="{{question.name}} input field" maxlength="11"
                            (keypress)="keyPressNumberField($event)">

                        <div *ngIf="submitted && bookingForm[question.reference].errors?.required" role="alert"
                            tabindex="0" class="invalid-feedback">
                            {{question.name}} {{'COMMON.IS_REQUIRED' | translate}}
                        </div>

                        <span *ngIf="question.help_text" class="help-text mb-3" tabindex="0"
                            [innerHTML]="question.help_text">
                        </span>
                    </div>

                    <!-- select dropdown-->
                    <div class="form-group"
                        *ngIf="question.visible && !question.admin_only && question.detail_type == 'select'">
                        <label><span aria-hidden="true" class="form-field-required-marker" *ngIf="question.required">
                                *</span> {{question.name}}</label>
                        <select formControlName="{{question.reference}}" [value]='-1' class="form-control"
                            (change)="onQuestionChange()" attr.aria-label="{{question.name}}" disabled>
                            <option></option>
                            <option *ngFor="let option of question.options" [value]="option.name">
                                {{option.name}}
                            </option>
                        </select>
                        <!-- <ng-container *ngIf="question.name === 'Vehicle type' && this.myVehicles.length > 0">
                            
                        </ng-container>
                        <ng-container *ngIf="!(question.name === 'Vehicle type' && this.myVehicles.length > 0)">
                            <select formControlName="{{question.reference}}" [value]='-1' class="form-control"
                                (change)="onQuestionChange()" attr.aria-label="{{question.name}}">
                                <option></option>
                                <option *ngFor="let option of question.options" [value]="option.name">
                                    {{option.name}}
                                </option>
                            </select>
                        </ng-container> -->


                        <div *ngIf="submitted && bookingForm[question.reference].errors?.required" role="alert"
                            tabindex="0" class="invalid-feedback">
                            {{question.name}} {{'COMMON.IS_REQUIRED' | translate}}</div>

                        <span *ngIf="question.help_text" class="help-text mb-3" tabindex="0"
                            [innerHTML]="question.help_text">
                        </span>
                    </div>

                    <!-- checkbox -->
                    <div style="margin-bottom: 0px !important;" class="form-group"
                        *ngIf="question.visible && !question.admin_only && question.detail_type == 'check' || question.visible && !question.admin_only && question.detail_type == 'check-price'">
                        <div class="bb-flex  row-blocks">

                        </div>
                        <div class="bb-flex  row-blocks">
                            <mat-checkbox formControlName="{{question.reference}}" id="{{question.reference}}"
                                class="pb-3">
                                <label for="{{question.reference}}" style="line-height: 0.8;"><span
                                        *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                                        * </span>
                                    <span *ngIf="question.price == 0">{{question.name}}</span>

                                    <span tabindex="-1" *ngIf="question.price > 0">{{question.name}} -
                                        {{question.price / 100 | currency:'GBP':true}}</span>
                                </label>
                                <br>
                            </mat-checkbox>


                            <span *ngIf="question.help_text" class="help-text mb-3 pb-3" tabindex="0"
                                [innerHTML]="question.help_text">
                            </span>
                        </div>
                    </div>

                    <!-- radio -->
                    <div class="row-blocks"
                        *ngIf="question.visible && !question.admin_only && question.detail_type == 'radio'">
                        <label>
                            <span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">*
                            </span> {{question.name}}</label>

                        <mat-radio-group formControlName="{{question.reference}}" class="col-sm-7 radio-group"
                            (change)="onQuestionChange()">
                            <mat-radio-button class="radio-button" *ngFor="let option of question.options"
                                [value]="option.name">
                                {{option.name}}
                            </mat-radio-button>
                        </mat-radio-group>

                        <div *ngIf="submitted && bookingForm[question.reference].errors?.required" role="alert"
                            tabindex="0" class="invalid-feedback">
                            {{question.name}} {{'COMMON.IS_REQUIRED' | translate}}
                        </div>
                        <span *ngIf="question.help_text" class="help-text mb-3" tabindex="0"
                            [innerHTML]="question.help_text">
                        </span>
                        <br *ngIf="question.help_text">
                    </div>
                    <!-- br instead of changing css -->
                </div>
            </form>
        </div>
    </div>

    <div *ngIf="submitted && validationError" role="alert" tabindex="0" class="invalid-feedback">
        {{'FORM.VALIDATION_ERR_MSG' | translate}}
    </div>
    <div mat-dialog-actions class="row">
        <div class="col-sm-6">
            <button (click)="onNoClick()" class="btn btn-primary govuk-button button-sizer button-auto"
                style="text-align: center;">Close</button>
        </div>
        <div class="col-sm-6 text-right" *ngIf="data.action === 'cancel'">
            <button class="btn btn-primary govuk-button button-sizer button-auto" (click)="continue()"
                *ngIf="cancelMessage" [disabled]="cancelPassed">{{'ACCOUNT.CONTINUE' | translate}}</button>
            <button class="btn btn-primary govuk-button button-sizer  button-auto cancel-btn" style="float: right;"
                (click)="cancelBooking(data.member, data.booking)" *ngIf="cancelPromptMessage">{{'ACCOUNT.YES' |
                translate}}</button>
        </div>

        <div class="col-sm-6 text-right" *ngIf="data.action === 'modify'">
            <button class="btn btn-primary govuk-button button-sizer  button-auto" style="float: right;"
                (click)="confirmAmend(data.booking, selectedSlot, data.member)">{{'ACCOUNT.RESCHEDULE_BOOKING' |
                translate}}</button>
        </div>
        <div class="col-sm-6 text-right" *ngIf="data.action === 'details'">
            <button *ngIf="showQuestions === true" class="btn btn-primary govuk-button button-sizer  button-auto"
                (click)="saveBooking()" style="float: right;">Save</button>
            <button *ngIf="showQuestions === true" (click)="showQuestions = false"
                class="btn btn-primary govuk-button button-sizer button-auto"
                style="text-align: center; margin-right: 20px; float: right;">Cancel</button>
            <button *ngIf="showQuestions === false" (click)="showQuestions = true"
                class="btn btn-primary govuk-button button-sizer button-auto"
                style="text-align: center; float: right;">Amend
                details</button>
        </div>
    </div>